import _JSXStyle from "styled-jsx/style";
import { theme } from '@dhis2/ui-constants';
import PropTypes from 'prop-types';
import React from 'react';
const centerButtonStyles = ["svg.jsx-2392683210{min-width:20px;}", "div.centerButton.jsx-2392683210:dir(rtl){-webkit-transform:rotate(180deg) translateX(4px);-ms-transform:rotate(180deg) translateX(4px);transform:rotate(180deg) translateX(4px);}"];
centerButtonStyles.__hash = "2392683210";
export const IconAddAll = _ref => {
  let {
    dataTest,
    disabled
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "jsx-".concat(centerButtonStyles.__hash) + " " + "centerButton"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "data-test": dataTest,
    fill: disabled ? theme.disabled : '#404B5A',
    className: "jsx-".concat(centerButtonStyles.__hash)
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    className: "jsx-".concat(centerButtonStyles.__hash)
  }, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "nonzero",
    points: "6 2 4.94 3.06 9.13 7.25 0 7.25 0 8.75 9.13 8.75 4.94 12.94 6 14 12 8",
    className: "jsx-".concat(centerButtonStyles.__hash)
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "nonzero",
    points: "10 2 8.94 3.06 13.13 7.25 13.9 8 13.13 8.75 8.94 12.94 10 14 16 8",
    className: "jsx-".concat(centerButtonStyles.__hash)
  }))), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: centerButtonStyles.__hash
  }, centerButtonStyles));
};
IconAddAll.propTypes = {
  dataTest: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};
export const IconAddIndividual = _ref2 => {
  let {
    dataTest,
    disabled
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: "jsx-".concat(centerButtonStyles.__hash) + " " + "centerButton"
  }, /*#__PURE__*/React.createElement("svg", {
    fill: disabled ? theme.disabled : '#404B5A',
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "data-test": dataTest,
    className: "jsx-".concat(centerButtonStyles.__hash)
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "8 2 6.94 3.06 11.13 7.25 2 7.25 2 8.75 11.13 8.75 6.94 12.94 8 14 14 8",
    className: "jsx-".concat(centerButtonStyles.__hash)
  })), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: centerButtonStyles.__hash
  }, centerButtonStyles));
};
IconAddIndividual.propTypes = {
  dataTest: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};
export const IconRemoveAll = _ref3 => {
  let {
    dataTest,
    disabled
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", {
    className: "jsx-".concat(centerButtonStyles.__hash) + " " + "centerButton"
  }, /*#__PURE__*/React.createElement("svg", {
    fill: disabled ? theme.disabled : '#404B5A',
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    "data-test": dataTest,
    xmlns: "http://www.w3.org/2000/svg",
    className: "jsx-".concat(centerButtonStyles.__hash)
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    className: "jsx-".concat(centerButtonStyles.__hash)
  }, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "nonzero",
    points: "10 2 8.94 3.06 13.13 7.25 4 7.25 4 8.75 13.13 8.75 8.94 12.94 10 14 16 8",
    transform: "matrix(-1 0 0 1 20 0)",
    className: "jsx-".concat(centerButtonStyles.__hash)
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "nonzero",
    points: "1.06 2 0 3.06 4.19 7.25 4.96 8 4.19 8.75 0 12.94 1.06 14 7.06 8",
    transform: "matrix(-1 0 0 1 7.06 0)",
    className: "jsx-".concat(centerButtonStyles.__hash)
  }))), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: centerButtonStyles.__hash
  }, centerButtonStyles));
};
IconRemoveAll.propTypes = {
  dataTest: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};
export const IconRemoveIndividual = _ref4 => {
  let {
    dataTest,
    disabled
  } = _ref4;
  return /*#__PURE__*/React.createElement("div", {
    className: "jsx-".concat(centerButtonStyles.__hash) + " " + "centerButton"
  }, /*#__PURE__*/React.createElement("svg", {
    fill: disabled ? theme.disabled : '#404B5A',
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "data-test": dataTest,
    className: "jsx-".concat(centerButtonStyles.__hash)
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "8 2 6.94 3.06 11.13 7.25 2 7.25 2 8.75 11.13 8.75 6.94 12.94 8 14 14 8",
    transform: "matrix(-1 0 0 1 16 0)",
    className: "jsx-".concat(centerButtonStyles.__hash)
  })), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: centerButtonStyles.__hash
  }, centerButtonStyles));
};
IconRemoveIndividual.propTypes = {
  dataTest: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};
export const IconMoveDown = _ref5 => {
  let {
    dataTest,
    disabled
  } = _ref5;
  return /*#__PURE__*/React.createElement("svg", {
    fill: disabled ? theme.disabled : '#404B5A',
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "8 2 6.94 3.06 11.13 7.25 2 7.25 2 8.75 11.13 8.75 6.94 12.94 8 14 14 8",
    transform: "matrix(0 1 1 0 0 0)"
  }));
};
IconMoveDown.propTypes = {
  dataTest: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};
export const IconMoveUp = _ref6 => {
  let {
    dataTest,
    disabled
  } = _ref6;
  return /*#__PURE__*/React.createElement("svg", {
    fill: disabled ? theme.disabled : '#404B5A',
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "8 2 6.94 3.06 11.13 7.25 2 7.25 2 8.75 11.13 8.75 6.94 12.94 8 14 14 8",
    transform: "rotate(-90 8 8)"
  }));
};
IconMoveUp.propTypes = {
  dataTest: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};